import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import styled from 'styled-components';
import Colors from '../../../styles/colors';
import commonStyles from '../../../styles/commonStyles';
import { FlexDiv, HigherPlanTag, LoadingWrapper } from '../../../styles/styled';
import Loading from '../../../components/Loading';
import {
  ActionButton,
  OrangeSubmitButton,
  ButtonConfirm,
} from '../../../components/buttons/buttons';
import SoundcastsTabs from '../../../components/soundcasts_tabs';
import { getUsageLimit } from '../../../helpers/userinfoHelper';
import VerificationCode from '../components/soundcast/verificationcode';
import YoutubeConnection from './youtube_channel_connection';
import getPath from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { publisherManager } from '../../../helpers/managers';
import { ALERTS } from '../../../helpers/texts';
const isSoundcastDoesNotExist = id => isEmpty(id) || id === 'CREATE_NEW';

function Modal(props) {
  let soundcast = props.userInfo.soundcasts_managed[props.currentSoundCastId];
  return (
    <div style={styles.backDrop} onClick={props.closeModal}>
      <div style={styles.modal}>
        <div
          style={{
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'flex-end',
            paddingTop: '12px',
            paddingRight: '12px',
          }}
          onClick={props.closeModal}>
          <i className="fa fa-times fa-1x" />
        </div>
        <p style={{ textAlign: 'center', margin: '35px 60px', fontSize: '14px' }}>
          You need to upload intro and/or outro to{' '}
          <strong>{props.userInfo.soundcasts_managed[props.currentSoundCastId].title}</strong> first
          to enable this option
        </p>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <OrangeSubmitButton
            label="Add intro/outro audio to soundcast"
            onClick={() =>
              props.history.push({
                pathname: '/dashboard/edit/' + props.currentSoundCastId,
                state: {
                  id: props.currentSoundCastId,
                  soundcast,
                },
              })
            }
            styles={{
              fontSize: '14px',
              letterSpacing: '1px',
              wordSpacing: '2px',
              margin: '0px auto',
              padding: '2px 10px 33px',
              height: '27px',
              backgroundColor: Colors.mainOrange,
              borderWidth: '0px',
              width: 'auto',
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default class SoundcastsConversions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      integrationSelected: '',
      userInfo: { soundcasts_managed: {} },
      currentSoundCastId: '',
      introOutro: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    if (this.props.userInfo) {
      const { userInfo } = this.props;
      this.setState({ userInfo });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.userInfo) {
      const { userInfo } = nextProps;
      return { userInfo };
    }
    return null;
  }

  closeModal() {
    this.setState({ introOutro: false });
  }

  openModal(id) {
    this.setState({ introOutro: true, currentSoundCastId: id });
  }

  render() {
    const { userInfo, integrationSelected, introOutro, currentSoundCastId } = this.state;
    const { history, id } = this.props;

    return (
      <div style={{ minHeight: 700 }}>
        {introOutro && (
          <Modal
            closeModal={this.closeModal}
            currentSoundCastId={currentSoundCastId}
            userInfo={userInfo}
            history={history}
          />
        )}
        <SoundcastsTabs active="conversions" />
        <div style={{ padding: 30, background: '#fff', margin: `10px 10px 10px 0px` }}>
          <div style={{ maxWidth: 720 }}>
            <div style={{ fontSize: 18, margin: `8px 0 30px 0` }}>
              Convert other media products into soundcasts
            </div>
            <IntegrationItemDivision>
              <span className="column-title">Convert from</span>
              <div className="column-inputs dropdown">
                <div className="btn dropdown-toggle" data-toggle="dropdown">
                  <div style={styles.dropdownTitle}>
                    <span style={{ ...styles.titleText, padding: '20px' }}>
                      {integrationSelected != '' ? integrationSelected : `Choose conversion source`}
                    </span>
                    <span style={{ position: 'absolute', right: 10, top: 20 }} className="caret" />
                  </div>
                </div>
                <ul className="dropdown-menu" style={{ width: '100%', padding: 0 }}>
                  <li style={{ fontSize: '16px', width: '100%' }}>
                    <button
                      style={{ ...styles.categoryButton, width: '100%' }}
                      onClick={() => this.setState({ integrationSelected: 'YouTube' })}>
                      YouTube
                    </button>
                  </li>
                  <li style={{ fontSize: '16px', width: '100%' }}>
                    <button
                      style={{ ...styles.categoryButton, width: '100%' }}
                      onClick={() => this.setState({ integrationSelected: 'RSS Feed' })}>
                      RSS feed
                    </button>
                  </li>
                </ul>
              </div>
            </IntegrationItemDivision>
            {integrationSelected === '' ? null : (
              <IntegrationView
                integrationSelected={integrationSelected}
                openModal={this.openModal}
                userInfo={userInfo}
                history={history}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const IntegrationView = props => {
  const { integrationSelected, openModal, userInfo, history } = props;
  if (integrationSelected === 'YouTube') {
    return <YouTubeView openModal={openModal} userInfo={userInfo} history={history} />;
  } else if (integrationSelected === 'RSS Feed') {
    return <RSSFeedView openModal={openModal} userInfo={userInfo} />;
  }
};

class RSSFeedView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rssFeedUrl: '',
      rssFeedList: [],
      submitted: false,
      showVerificationCode: false,
      verificationCode: null,
      resendCode: false,
      loader: {
        show: false,
        msg: 'Loading...',
      },
    };
    this.submitS3Feed = this.submitS3Feed.bind(this);
    this.removeS3Feed = this.removeS3Feed.bind(this);
    this.showLoader = this.showLoader.bind(this);
  }

  componentDidMount() {
    const { loader } = this.state;
    this.setState({ loader: { ...loader, show: true } });
    Axios.post('/api/parse_feed_to_s3', {
      retrieveList: true,
      userId: this.props.userInfo.id,
      publisherId: this.props.userInfo.publisherID,
    })
      .then(res => this.setState({ rssFeedList: res.data, loader: { ...loader, show: false } }))
      .catch(err => {
        this.setState({ loader: { ...loader, show: false } });
        const errMsg = `${(err && err.response && err.response.data) || err}`;
        const message = `Error: rss feed retrieval ${errMsg}`;
        console.error(message);
        alert(message);
      });
  }

  showLoader(isShow) {
    const { loader } = this.state;
    this.setState({ loader: { ...loader, show: isShow } });
  }

  submitS3Feed() {
    if (!this.state.rssFeedUrl) {
      return alert('Please enter RSS Feed URL!');
    }

    this.showLoader(true);

    const newRssFeedRow = {
      feedUrl: this.state.rssFeedUrl,
      userId: this.props.userInfo.id,
      publisherId: this.props.userInfo.publisherID,
      verificationCode: this.state.verificationCode || null,
      resendCode: this.state.resendCode || false,
    };
    Axios.post('/api/parse_feed_to_s3', newRssFeedRow)
      .then(res => {
        const status = getPath(res, 'data.status', null);
        if (status === 'sentVerificationCode') {
          this.setState({
            showVerificationCode: true,
            resendCode: false,
          });
          this.showLoader(false);
        } else if (status === 'confirmed') {
          const soundcastId = getPath(res, 'data.soundcastId', null);
          newRssFeedRow.soundcastId = soundcastId;
          delete newRssFeedRow.verificationCode;
          const rssFeedList = [...this.state.rssFeedList, newRssFeedRow];
          this.setState(
            {
              rssFeedUrl: '',
              showVerificationCode: false,
              verificationCode: null,
              rssFeedList,
            },
            () => {
              this.showLoader(false);
              alert('Successfully submitted!');
            }
          );
        } else {
          this.showLoader(false);
        }
      })
      .catch(err => {
        this.showLoader(false);
        const errMsg = `${(err && err.response && err.response.data) || err}`;
        const message = `Error: submitS3Feed ${errMsg}`;
        console.error(message);
        alert(message);
      });
  }

  removeS3Feed(idx) {
    return () => {
      this.showLoader(true);
      const { soundcastId } = this.state.rssFeedList[idx];
      Axios.post('/api/parse_feed_to_s3', { soundcastId, deleteSubscription: true })
        .then(res => {
          const rssFeedList = this.state.rssFeedList.filter(i => i.soundcastId !== soundcastId);
          this.setState({ rssFeedList }, () => {
            this.showLoader(false);
            alert('Successfully deleted!');
          });
        })
        .catch(err => {
          this.showLoader(false);
          const errMsg = `${(err && err.response && err.response.data) || err}`;
          console.error(`Error: removeS3Feed ${errMsg}`);
        });
    };
  }

  resendCode() {
    this.setState({ verificationCode: null, resendCode: true }, () => this.submitS3Feed());
  }

  setVerificationCode = code => {
    this.setState({ verificationCode: code });
  };

  render() {
    const { publisher } = this.props.userInfo;
    const { showVerificationCode, rssFeedList, loader } = this.state;
    return (
      <div className="row">
        {!loader.show && !showVerificationCode && (
          <div>
            <div className="col-xs-12" style={{ fontSize: 16 }}>
              Podcast RSS Feed URL
            </div>
            <div className="col-xs-9">
              <input
                type="text"
                style={{ ...styles.input, marginTop: 9, marginBottom: 2 }}
                onChange={e => this.setState({ rssFeedUrl: e.target.value })}
                value={this.state.rssFeedUrl}
              />
            </div>
            <div className="col-xs-3">
              <OrangeSubmitButton
                styles={{ marginTop: 7, marginBottom: 15, width: `100%` }}
                label="Submit"
                onClick={this.submitS3Feed}
              />
            </div>

            <div style={{ fontSize: 16 }}>
              {rssFeedList.map((i, idx) => {
                return (
                  <div key={`rssFeedList${idx}`}>
                    <div className="col-xs-9" style={{ wordBreak: `break-all`, paddingTop: 5 }}>
                      {i.feedUrl}
                    </div>
                    <div
                      className="col-xs-3"
                      style={{ cursor: `pointer`, color: Colors.link, paddingTop: 5 }}
                      onClick={this.removeS3Feed(idx)}>
                      Stop feed import
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {loader.show && (
          <LoadingWrapper height="auto">
            <Loading text={loader.msg} align="center" size={50} fontSize={1.6} />
          </LoadingWrapper>
        )}

        {!loader.show && showVerificationCode && (
          <VerificationCode
            publisher={publisher}
            submitCodeHandler={this.submitS3Feed.bind(this)}
            resendCodeHandler={this.resendCode.bind(this)}
            setVerificationCode={this.setVerificationCode.bind(this)}></VerificationCode>
        )}
      </div>
    );
  }
}

class YouTubeView extends Component {
  constructor(props) {
    super(props);
    this.isAuthorized = this.isAuthorized.bind(this);
    this.deleteConversion = this.deleteConversion.bind(this);
    this.updateRequest = this.updateRequest.bind(this);
    this.signInYouTube = this.signInYouTube.bind(this);
    this.handleAuthClick = this.handleAuthClick.bind(this);
    this.getChannelPlaylists = this.getChannelPlaylists.bind(this);
    this.writeData = this.writeData.bind(this);
    this.sendAxiosRequest = this.sendAxiosRequest.bind(this);
    this.execApiRequest = this.execApiRequest.bind(this);
    this.showAlert = this.showAlert.bind(this);

    this.state = {
      connectionRequests: [],
      soundcastsManaged: [],
      modal: {
        show: false,
        title: '',
        content: '',
        upgrade: false,
        confirm: {},
        actionLabel: '',
        onClose: () => {},
      },
    };
  }

  componentDidMount() {
    this.onMountOrReceiveProps(this.props, null);
    // this.isAuthorized() && this.getChannelPlaylists(); // old logic to load single channel data
  }

  componentWillReceiveProps(nextProps) {
    this.onMountOrReceiveProps(null, nextProps);
  }

  async onMountOrReceiveProps(currentProps, nextProps) {
    const props = currentProps || nextProps || {};
    const { userInfo } = props;
    if (userInfo && userInfo.publisher) {
      const soundcastsManaged = [];
      const managedIds = Object.keys(userInfo.soundcasts_managed || {});
      if (managedIds.length && typeof Object.values(userInfo.soundcasts_managed)[0] === 'object') {
        for (const id of managedIds) {
          const soundcast = JSON.parse(JSON.stringify(userInfo.soundcasts_managed[id]));
          if (soundcast.title) {
            soundcast.id = id;
            soundcastsManaged.push(soundcast);
          }
        }
      }

      // Load "connectionRequests" from  youtubeConnect / soundcastFromYoutube  lists
      const connectionRequests = [];
      let youtubeConnect = userInfo.publisher.youtubeConnect || {};
      let soundcastFromYoutube = userInfo.publisher.soundcastFromYoutube || {};

      if (soundcastFromYoutube && soundcastFromYoutube.soundcastId) {
        // - suggest connection has old-form (single connection per publisher), updating:
        const { soundcastId } = soundcastFromYoutube;

        await publisherManager.removeProp(userInfo.publisherID, 'soundcastFromYoutube');
        await publisherManager.saveProp(
          userInfo.publisherID,
          `soundcastFromYoutube/${soundcastId}`,
          soundcastFromYoutube
        );

        const soundcastFromYoutubeFixed = {};
        soundcastFromYoutubeFixed[soundcastId] = soundcastFromYoutube;
        soundcastFromYoutube = soundcastFromYoutubeFixed;

        await publisherManager.removeProp(userInfo.publisherID, 'youtubeConnect');
        await publisherManager.saveProp(
          userInfo.publisherID,
          `youtubeConnect/${soundcastId}`,
          youtubeConnect
        );

        const youtubeConnectFixed = {};
        youtubeConnectFixed[soundcastId] = youtubeConnect;
        youtubeConnect = youtubeConnectFixed;
      }

      const youtubeConnectSoundcastIds = Object.keys(youtubeConnect);
      for (const id of youtubeConnectSoundcastIds) {
        // if connect errored and not in soundcastFromYoutube, remove the node to startover
        if (!soundcastFromYoutube[id] && youtubeConnect[id].includes('ERROR:')) {
          // delete the node temporarily (need to find another solution)
          await publisherManager.removeProp(userInfo.publisherID, `youtubeConnect/${id}`);
          continue;
        }

        if (youtubeConnect[id] === 'REQUESTED' && soundcastFromYoutube[id]) {
          await publisherManager.saveProp(
            userInfo.publisherID,
            `youtubeConnect/${id}`,
            'CONNECTED'
          );
        }

        let connectstatus = 'NEVERCONNECTED';
        if (!youtubeConnect[id] || youtubeConnect[id] !== 'REQUESTED') {
          connectstatus = 'NEVERCONNECTED';
        } else {
          connectstatus = youtubeConnect[id] === 'REQUESTED' ? 'REQUESTED' : 'DISCONNECTED';
        }

        if (!soundcastFromYoutube[id]) {
          // Set "Channel conversion is in progress" label
          connectionRequests.push({ connected: false, requested: connectstatus });
        } else {
          const connected = connectstatus !== 'DISCONNECTED';
          if (connected) {
            const { audioProcessingOptions } = soundcastFromYoutube[id];
            const connectedSoundcast =
              userInfo.soundcasts_managed && userInfo.soundcasts_managed[id];

            // Get the itunesCategory
            const categoryLength =
              connectedSoundcast &&
              connectedSoundcast.itunesCategory &&
              connectedSoundcast.itunesCategory.length;
            const ituneCat1 = categoryLength > 0;
            const ituneCat2 = categoryLength > 1;
            const ituneCat3 = categoryLength > 2;

            // Get if the material contains explicit language. We aren't using this from soundcast,
            // instead we pick up the value set by the server in audioProcessingOptions.
            // const explicit = connectedSoundcast && connectedSoundcast.itunesExplicit;

            const connectionRequest = {
              connected,
              requested: connectstatus,
              connectedSoundcast,
              soundcastFromYoutube: soundcastFromYoutube[id],
              channel: { id: soundcastFromYoutube[id].channelId || '' },
              channelName: soundcastFromYoutube[id].channelName || '',
              playlistName: soundcastFromYoutube[id].playlistName || '',
              playlistId: soundcastFromYoutube[id].playlistId || '',
              soundcast_Id: id,
              itunesExplicit: audioProcessingOptions.itunesExplicit,
              itune1: ituneCat1 ? connectedSoundcast.itunesCategory[0] : '',
              itune2: ituneCat2 ? connectedSoundcast.itunesCategory[1] : '',
              itune3: ituneCat3 ? connectedSoundcast.itunesCategory[2] : '',
              setVolume: audioProcessingOptions.setVolume,
              trimSilence: audioProcessingOptions.trim,
              introOutro: audioProcessingOptions.intro || audioProcessingOptions.outro,
              overlayDuration: audioProcessingOptions.overlayDuration,
              createPodcastFeed: audioProcessingOptions.createChannelFeed || false,
            };

            let autoSubmitPodcastUpdated = true;
            if (connectedSoundcast) {
              // This means there is a valid soundcast connected.
              autoSubmitPodcastUpdated = false;
            }
            const autoSubmitPodcast = connectedSoundcast && connectedSoundcast.autoSubmitPodcast;
            if (autoSubmitPodcastUpdated) {
              // Only update state on mount, if value changes in between,
              // the component manages the state. Updating from firebase
              // Causes a flickr on the toggle.
              // Note this is different from rest as it comes from soundcast
              // database in firebase and not the publisher.
              connectionRequest.submitFeed = autoSubmitPodcast;
            }
            if (typeof connectionRequest.submitFeed === 'undefined') {
              connectionRequest.submitFeed = true;
            }

            connectionRequests.push(connectionRequest);
          }
        }
      }

      this.setState({ connectionRequests, soundcastsManaged });
    }
  }

  isAuthorized() {
    return GoogleAuth ? GoogleAuth.currentUser.get().hasGrantedScopes(SCOPE) : false;
  }

  deleteConversion(idx) {
    return () => {
      if (GoogleAuth) {
        // updateSigninStatus will be invoked on sign in status change.
        GoogleAuth.signOut();
      }
      const connectionRequests = this.state.connectionRequests.slice(); // copy array
      connectionRequests.splice(idx, 1); // remove element
      this.setState({ connectionRequests });
    };
  }

  updateRequest(idx) {
    return newState => {
      const keys = Object.keys(newState || {});
      const connectionRequests = this.state.connectionRequests.slice(); // copy array
      for (const key of keys) {
        connectionRequests[idx][key] = newState[key]; // set new value
      }
      this.setState({ connectionRequests });
    };
  }

  signInYouTube(callback) {
    if (GoogleAuth) {
      if (!this.GoogleAuthIsSignedInitialized) {
        this.GoogleAuthIsSignedInitialized = true; // lock
        GoogleAuth.isSignedIn.listen(status => {
          if (this.isAuthorized()) {
            this.getChannelPlaylists();
            typeof callback === 'function' && callback();
          }
        });
      }
      GoogleAuth.signIn();
    } else {
      this.showAlert({ content: `There is a problem with Google Sign In.` });
    }
  }

  getAccessLimits() {
    const { connectionRequests = 0 } = this.state;
    const allowedConnects = getUsageLimit('ALLOWED_YOUTUBE_CONNECT');
    const access = {
      noAccess: allowedConnects === 0,
      limitExceeded: false,
    };

    if (connectionRequests.length >= allowedConnects) {
      access.limitExceeded = true;
    }

    return access;
  }

  handleAuthClick(callback) {
    const { userInfo } = this.props;
    const access = this.getAccessLimits();
    if (access.limitExceeded) {
      const content = access.noAccess
        ? ALERTS().ALLOWED_YOUTUBE_CONNECT.NO_ACCESS
        : ALERTS().ALLOWED_YOUTUBE_CONNECT.LIMIT_EXCEEDED;

      return this.showAlert({ title: 'Upgrade Required', content, upgrade: true });
    }

    // We setState here, so that there is a rerender on signon on change channel.
    // We check for GoogleAuth to be defined as there could be a scenario when
    // it becomes undefined after a user logs out.
    if (this.isAuthorized()) {
      GoogleAuth.signOut().then(() => this.signInYouTube(callback));
    } else {
      this.signInYouTube(callback);
    }
  }

  getChannelPlaylists() {
    gapi.client.youtube.channels
      .list({
        part: 'snippet,contentDetails,statistics,status',
        mine: 'true',
      })
      .then(async response => {
        // Obtain channel info:
        const channel = response.result.items[0];
        const channelsResult = await this.execApiRequest('GET', '/youtube/v3/channels', {
          id: channel.id,
          part: 'snippet,contentDetails,statistics,status',
        });
        if (channelsResult.kind !== 'youtube#channelListResponse') {
          console.error(`Error: channelsResult wrong kind `, channelsResult);
        }

        // Obtain playlists:
        const playlists = [];
        const reqParams = {
          channelId: channel.id,
          maxResults: '50',
          part: 'snippet,contentDetails,status',
        };
        while (true) {
          const result = await this.execApiRequest('GET', '/youtube/v3/playlists', reqParams);
          if (result.kind !== 'youtube#playlistListResponse') {
            console.error(`Error: playlists result wrong kind `, result);
            continue;
          }
          if (result && result.items && result.items.length) {
            playlists.push(...result.items);
          }
          if (result.nextPageToken) {
            reqParams.pageToken = result.nextPageToken; // set next page token
          } else {
            break; // break while loop
          }
        }

        const { connectionRequests } = this.state;
        connectionRequests.push({
          soundcast_Id: '',
          channel: channelsResult.items[0],
          playlists,
          requested: 'NEVERCONNECTED',
          itunesExplicit: true,
          submitFeed: true,
          newSoundcastId: `${Date.now()}s`,
        });
        this.setState({ connectionRequests });
      });
  }

  execApiRequest(method, path, params, properties) {
    const options = { method, path, params: this.removeEmptyParams(params) };
    if (properties) {
      options.body = this.createResource(properties);
    }
    return new Promise(resolve => gapi.client.request(options).execute(resolve));
  }

  // Boilerplate from https://developers.google.com/youtube/v3/docs/channels/list
  createResource(properties) {
    var resource = {};
    var normalizedProps = properties;
    for (var p in properties) {
      var value = properties[p];
      if (p && p.substr(-2, 2) == '[]') {
        var adjustedName = p.replace('[]', '');
        if (value) {
          normalizedProps[adjustedName] = value.split(',');
        }
        delete normalizedProps[p];
      }
    }
    for (var p in normalizedProps) {
      // Leave properties that don't have values out of inserted resource.
      if (normalizedProps.hasOwnProperty(p) && normalizedProps[p]) {
        var propArray = p.split('.');
        var ref = resource;
        for (var pa = 0; pa < propArray.length; pa++) {
          var key = propArray[pa];
          if (pa == propArray.length - 1) {
            ref[key] = normalizedProps[p];
          } else {
            ref = ref[key] = ref[key] || {};
          }
        }
      }
    }
    return resource;
  }

  removeEmptyParams(params) {
    for (var p in params) {
      if (!params[p] || params[p] == 'undefined') {
        delete params[p];
      }
    }
    return params;
  }

  checkIfUserIsPublisher(userInfo) {
    if (userInfo.publisherID != null) {
      return true;
    }
    this.showAlert({ content: 'Only for soundcast publishers.' });
  }

  async writeData(e, skipChannelConversion, connectionRequests) {
    e && e.preventDefault();
    const { userInfo } = this.props;

    const errorMessage = 'There was an error sending your conversion request.';
    const successMessage = skipChannelConversion
      ? 'Settings are saved.'
      : 'Conversion request registered.';

    const results = await Promise.all(
      connectionRequests.map(connectionRequest => {
        return new Promise(async resolve => {
          const {
            soundcast_Id,
            itune1,
            itune2,
            itune3,
            channel,
            playlistId,
            playlistName,
            submitFeed,
            trimSilence,
            introOutro,
            overlayDuration,
            setVolume,
            createPodcastFeed,
            itunesExplicit,
            newSoundcastId,
            itunesImage,
          } = connectionRequest;

          if (this.checkIfUserIsPublisher(userInfo)) {
            const itunesCategory = [itune1];
            itune2 && itunesCategory.push(itune2);
            itune3 && itunesCategory.push(itune3);

            // Check if there already exists a podcast feed URL.
            // If an URL exists from before, we would need to set the createChannelFeed to true.
            const soundcasts_managed = userInfo.soundcasts_managed || {};
            let UrlExists =
              typeof (soundcasts_managed[soundcast_Id] || {}).podcastFeedVersion === 'undefined'
                ? false
                : true;

            const newSoundcast = isSoundcastDoesNotExist(soundcast_Id);
            const soundcastId = newSoundcast ? newSoundcastId : soundcast_Id;

            if (isSoundcastDoesNotExist(soundcastId)) {
              const content = 'Error: intergrations writeData wrong soundcastId';
              console.error(content);
              return this.showAlert({ content });
            }

            const soundcastData = {
              newSoundcast,
              soundcastId,
              publisherId: userInfo.publisherID,
              creatorId: userInfo.id,
              channelId: channel.id,
              playlistId,
              itunesCategory,
              ...(isEmpty(itunesImage) ? {} : { itunesImage }),
              autoSubmitPodcast: submitFeed,
              skipChannelConversion,
              audioProcessingOptions: {
                trim: trimSilence,
                overlayDuration: introOutro ? overlayDuration : null,
                intro: introOutro ? (soundcasts_managed[soundcastId] || {}).intro : null,
                outro: introOutro ? (soundcasts_managed[soundcastId] || {}).outro : null,
                setVolume,
                tagging: true,
                createChannelFeed: createPodcastFeed || UrlExists,
                itunesExplicit,
              },
            };

            // save to firebase should be done first
            await publisherManager.saveProp(
              userInfo.publisherID,
              `youtubeConnect/${soundcastId}`,
              'REQUESTED'
            );

            this.sendAxiosRequest(soundcastData).then(
              res => {
                if (res === 204) {
                  // No Content
                  publisherManager.removeProp(userInfo.publisherID, `youtubeConnect/${soundcastId}`)
                    .then(() => {
                      const entity = isEmpty(playlistId) ? 'channel' : 'playlist';
                      const title = isEmpty(playlistId)
                        ? getPath(channel, 'snippet.title', '')
                        : playlistName;
                      const warningMessage = `The ${
                        isEmpty(title) ? '' : title + ' '
                      }${entity} is empty or contains no public videos.`;
                      return resolve(warningMessage);
                    })
                    .catch(() => {
                      return resolve(errorMessage);
                    });
                } else {
                  resolve(successMessage);
                }
              },
              err => {
                console.error(`Error: writeData promise error: ${err}`, connectionRequest);
                resolve(errorMessage);
              }
            );
          }
        }); // return new Promise(resolve ..
      }) // connectionRequests.map
    );

    const badMessage = results.find(item => item !== successMessage);
    const content = isEmpty(badMessage) ? successMessage : badMessage;

    setTimeout(() => this.showAlert({ content }), 300);
  }

  sendAxiosRequest(soundcastData) {
    const { userInfo } = this.props;
    return new Promise((resolve, reject) => {
      Axios.post('/api/parse_channel', soundcastData)
        .then(result => {
          if (!isEmpty(result)) {
            return resolve(result.status);
          }
          console.log('Submitted request');
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  modalHandler(metadata = {}) {
    let {
      show = false,
      title = '',
      content = '',
      actionLabel = '',
      upgrade = false,
      confirm = {},
      onClose = () => {},
    } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.modal;
      this.setState(
        {
          modal: {
            ...this.state.modal,
            show,
            title,
            content,
            actionLabel,
            upgrade,
            confirm,
            onClose,
          },
        },
        () => oldClose && !show && oldClose()
      );
    };
  }

  showAlert(metadata = {}) {
    this.modalHandler({
      show: true,
      ...metadata,
    })();
  }

  renderAlertModal() {
    const {
      show = false,
      title = '',
      content = '',
      upgrade = false,
      confirm = {},
      actionLabel = '',
    } = this.state.modal;
    let actions = null;
    const closeHandler = this.modalHandler({ show: false });

    if (isEmpty(confirm)) {
      const upgradeHandler = () => this.props.history.push('/pricing');
      const closeButtonLabel = actionLabel || (upgrade ? 'Cancel' : 'OK');

      actions = [
        <div style={{ textAlign: 'center', padding: 20 }}>
          {upgrade && (
            <ActionButton id="actionButtonUpgrade" onClick={upgradeHandler}>
              Upgrade
            </ActionButton>
          )}
          <ActionButton
            id="actionButtonClose"
            textColor={upgrade ? '#f76b1c' : null}
            backgroundColor={upgrade ? '#fff' : null}
            onClick={closeHandler}>
            {closeButtonLabel}
          </ActionButton>
        </div>,
      ];
    } else {
      const { ok = {}, cancel = {} } = confirm;
      const { text: okText = 'OK', onClick: okHandler = () => {} } = ok;
      const { text: cancelText = 'CANCEL', onClick: cancelHandler = () => {} } = cancel;
      const doHandler = action => {
        closeHandler();
        action();
      };

      actions = [
        <ButtonConfirm>
          <button className="cbtn" onClick={() => doHandler(okHandler)}>
            {okText}
          </button>
          <button className="cbtn cancel" onClick={() => doHandler(cancelHandler)}>
            {cancelText}
          </button>
        </ButtonConfirm>,
      ];
    }

    return (
      <Dialog
        title={
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
          </div>
        }
        actions={actions}
        modal={false}
        open={show}
        onRequestClose={this.modalHandler({ show: false })}>
        <div className="title-small" style={{ textAlign: 'center', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  render() {
    const { connectionRequests, soundcastsManaged } = this.state;
    const { publisher } = this.props.userInfo;
    const access = this.getAccessLimits();

    if (connectionRequests.length) {
      return (
        <div>
          {connectionRequests.map((i, idx) => {
            if (!('channel' in i)) return null;
            const youtubeConnect = (publisher && publisher.youtubeConnect) || {};
            const soundcastFromYoutube = (publisher && publisher.soundcastFromYoutube) || {};
            const connected =
              youtubeConnect[i.soundcast_Id] == 'REQUESTED' ||
              (youtubeConnect[i.soundcast_Id] == 'CONNECTED' &&
                soundcastFromYoutube[i.soundcast_Id]);
            return (
              <YoutubeConnection
                key={`ytconn${idx}`}
                userInfo={this.props.userInfo}
                openModal={this.props.openModal}
                deleteConversion={this.deleteConversion(idx)}
                updateRequest={this.updateRequest(idx)}
                writeData={this.writeData}
                connectionRequest={i}
                soundcastsManaged={soundcastsManaged}
                connected={i.connected}
                requested={i.requested}
                connectedSoundcast={i.connectedSoundcast}
                channel={i.channel}
                playlists={i.playlists}
                channelName={i.channelName}
                playlistName={i.playlistName}
                playlistId={i.playlistId}
                soundcast_Id={i.soundcast_Id}
                newSoundcastId={i.newSoundcastId}
                itunesExplicit={i.itunesExplicit}
                itune1={i.itune1}
                itune2={i.itune2}
                itune3={i.itune3}
                setVolume={i.setVolume}
                trimSilence={i.trimSilence}
                introOutro={i.introOutro}
                overlayDuration={i.overlayDuration}
                createPodcastFeed={i.createPodcastFeed}
                submitFeed={i.submitFeed}
                showAlert={this.showAlert}
              />
            );
          })}
          <div style={{ float: 'right', display: 'flex' }}>
            <OrangeSubmitButton
              label="Add another conversion"
              onClick={this.handleAuthClick}
              styles={{
                backgroundColor: Colors.mainOrange,
                border: 'none',
                width: 240,
                marginTop: 20,
              }}
            />
          </div>
          <MuiThemeProvider>{this.renderAlertModal()}</MuiThemeProvider>
        </div>
      );
    }

    return (
      <IntegrationItemDivision>
        <span className="column-title sm-display-none">&nbsp;</span>
        <div className="column-inputs">
          <FlexDiv alignItems="center">
            <OrangeSubmitButton
              label="Connect YouTube"
              onClick={this.handleAuthClick}
              styles={{
                backgroundColor: Colors.link,
                margin: 0,
                border: 'none',
                display: 'inline-block',
              }}
            />
            {access.noAccess && <HigherPlanTag className="margin-one-left" />}
          </FlexDiv>
        </div>
        <MuiThemeProvider>{this.renderAlertModal()}</MuiThemeProvider>
      </IntegrationItemDivision>
    );
  }
}

const IntegrationItemDivision = styled.div`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
  padding-bottom: 30px;
  display: flex;
  justify-content: space-between;

  .column-title {
    width: 150px;
    font-size: 16px;
    font-weight: 600;
    padding: 10px 0;
  }

  .column-inputs {
    flex: 1;

    &.self-align {
      &.center {
        align-self: center;
      }

      &.left {
        align-self: flex-start;
      }

      &.right {
        align-self: flex-end;
      }
    }

    &.dropdown {
      .dropdown-toggle {
        width: 100%;
        padding: 0px;
        border: 1px solid #dfdfdf;
      }
    }
  }

  @media (max-width: 991px) {
    flex-direction: column;

    .column-title {
      width: 100%;
    }

    .column-inputs {
      &.self-align {
        &.center {
          align-self: flex-start;
        }
      }
    }
  }
`;

SoundcastsConversions.propTypes = {
  userInfo: PropTypes.object,
  history: PropTypes.object,
  id: PropTypes.string,
};

const styles = {
  titleText: { ...commonStyles.titleText },
  dropdownTitle: { ...commonStyles.dropdownTitle },
  categoryButton: { ...commonStyles.categoryButton },
  input: { ...commonStyles.input },
  backDrop: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0px',
    left: '0px',
    right: '0px',
    zIndex: '9998',
    background: 'rgba(0, 0, 0, 0.3)',
  },
  modal: {
    position: 'absolute',
    top: '55%',
    left: '50%',
    width: '70%',
    height: '25vh',
    transform: 'translate(-50%, -50%)',
    zIndex: '9999',
    background: '#fff',
  },
  dialogTitle: {
    marginTop: 47,
    marginBottom: 49,
    textAlign: 'center',
    fontSize: 22,
  },
};
